import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { type AppProps } from 'next/app'
import Head from 'next/head'
import '../theme/Fonts.css'
import { ToastContainer } from 'react-toastify'

import { StylesReset } from 'theme/StylesReset'
import { TOAST_AUTO_CLOSE } from 'utils/toast'

import { RouteGuard } from '../components/RouteGuard/RouteGuard'
import { AuthContextProvider } from '../contexts/AuthContext'
import { CampaignsContextProvider } from '../contexts/CampaignsContext'

initializeApp({
  apiKey: process.env.NEXT_PUBLIC_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_MEASUREMENT_ID,
})

// Connects to functions emulator
if (process.env.NEXT_PUBLIC_FUNCTIONS_EMULATOR_PORT) {
  connectFunctionsEmulator(
    getFunctions(),
    'localhost',
    parseInt(process.env.NEXT_PUBLIC_FUNCTIONS_EMULATOR_PORT)
  )
}

// Connects to auth emulator
if (process.env.NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_URL) {
  const auth = getAuth()
  connectAuthEmulator(auth, process.env.NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_URL)
}

// Connects to store emulator
if (process.env.NEXT_PUBLIC_FIREBASE_STORE_EMULATOR_PORT) {
  const db = getFirestore()
  const port = parseInt(process.env.NEXT_PUBLIC_FIREBASE_STORE_EMULATOR_PORT)

  connectFirestoreEmulator(db, 'localhost', port)
}

function FitifyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <title>Fitify EMS</title>
      </Head>
      <StylesReset />
      <AuthContextProvider>
        <RouteGuard>
          <CampaignsContextProvider>
            <Component {...pageProps} />
          </CampaignsContextProvider>
        </RouteGuard>
        <ToastContainer
          autoClose={TOAST_AUTO_CLOSE}
          closeOnClick
          pauseOnHover
          position="bottom-right"
          theme="colored"
        />
      </AuthContextProvider>
    </>
  )
}

export default FitifyApp
